import { createGetEndpoint } from '@sonar-software/sonar-http';
import { ImportSummary } from '@types';

export const getSalesforceImportSummary = createGetEndpoint<void, ImportSummary>(
	'/api/v2/salesforce/Import/Summary'
);
